<script>
import dayjs from 'dayjs';
import {
  pageTitleMixin,
  prefetchDataMixin,
} from '@ubic/vue-mixins';
import { permissions } from '@/constants';
import ErrorAccessDenied from '@/components/ErrorAccessDenied';
import FormError from '@/components/FormError';
import DeleteWithConfirm from '@/components/DeleteWithConfirm';
import LogFields from './components/LogFields';
import service from './service';

export default {
  pageTitle: 'Детали записи лога',
  async prefetchData () {
    if (!this.hasReadPermission) {
      return;
    }

    this.isFetching = true;

    [this.data, this.workerOptions, this.projectOptions] = await Promise.all([
      service.getById(this.$route.params.id),
      this.hasWorkerReadPermission
        ? service.workerOptions()
        : [],
      this.hasProjectReadPermission
        ? service.projectOptions()
        : [],
    ]);

    this.fields = {
      worker: this.data.worker.id,
      project: this.data.project.id,
      hours: this.data.hours,
      date: dayjs(this.data.date).format('YYYY-MM-DD'),
      task: this.data.task,
    };

    this.isFetching = false;
  },
  mixins: [
    pageTitleMixin,
    prefetchDataMixin,
  ],
  data () {
    return {
      isFetching: false,
      isSaving: false,
      error: '',
      data: {},
      workerOptions: [],
      projectOptions: [],

      fields: {
        worker: '',
        project: '',
        date: '',
        hours: '',
        task: '',
      },
    };
  },
  computed: {
    hasReadPermission () {
      return this.$store
        .getters['auth/checkPermission'](permissions.LOG_READ);
    },
    hasTaskReadPermisson () {
      return this.$store
        .getters['auth/checkPermission'](permissions.LOG_READ_TASK);
    },
    hasWritePermission () {
      return this.$store
        .getters['auth/checkPermission'](permissions.LOG_WRITE);
    },
    hasWorkerReadPermission () {
      return this.$store
        .getters['auth/checkPermission'](permissions.WORKER_READ);
    },
    hasProjectReadPermission () {
      return this.$store
        .getters['auth/checkPermission'](permissions.PROJECT_READ);
    },
  },
  methods: {
    handleFieldsChange (fields) {
      this.fields = fields;
    },
    async handleSubmit (e) {
      e.preventDefault();

      if (this.isSaving) {
        return;
      }

      this.isSaving = true;
      this.error = '';

      try {
        await service.update(this.data.id, this.fields);

        this.emitDataUpdate();
        this.handleClose();
      } catch (error) {
        this.error = 'Ошибка при сохранении записи';
        this.isSaving = false;
      }
    },
    async handleRemove () {
      this.isFetching = true;

      try {
        await service.remove(this.data.id);

        this.emitDataUpdate();
        this.handleClose();
      } catch (error) {
        this.error = 'Ошибка при удалении записи';
        this.isSaving = false;
      }
    },

    handleClose () {
      this.$emit('close');
      this.$router.push({
        ...this.$route,
        path: '/logs',
      });
    },
    emitDataUpdate () {
      this.$emit('dataupdate');
    },
  },
  render () {
    if (!this.hasReadPermission) {
      return (
        <u-modal onClose={this.handleClose}>
          <ErrorAccessDenied />
        </u-modal>
      );
    }

    const {
      data,
      error,
      isSaving,
      hasWritePermission,
    } = this;

    return (
      <u-modal onClose={this.handleClose}>
        <u-title
          slot="header"
          level="2"
        >
          <span>
            Запись
            &nbsp;
          </span>
          <span slot="sub">
            {data.id}
          </span>
        </u-title>

        {this.isFetching ? (
          <u-spinner />
        ) : (
          <form
            action="#"
            method="post"
            onSubmit={this.handleSubmit}
          >
            <LogFields
              values={data}
              workerOptions={this.workerOptions}
              projectOptions={this.projectOptions}
              readonly={!hasWritePermission}
              disabled={isSaving}
              canReadTask={this.hasTaskReadPermisson}
              onChange={this.handleFieldsChange}
            />

            {Boolean(error) && (
              <FormError>
                {error}
              </FormError>
            )}

            {hasWritePermission && (
              <footer class="form-footer">
                <u-btn
                  type="submit"
                  size="wide"
                >
                  {isSaving
                    ? <u-spinner inline />
                    : 'Сохранить'}
                </u-btn>

                <span class="m-l-auto">
                  <DeleteWithConfirm onConfirm={this.handleRemove} />
                </span>
              </footer>
            )}
          </form>
        )}
      </u-modal>
    );
  },
};
</script>
